import { withContext } from './withContext'

import Text from 'components/ui/Text'

export default withContext(Text)